const locale = 'en-US';
const dateFormatParams = Object.freeze({ month: '2-digit', day: '2-digit', year: 'numeric' });
const timeFormatParams = Object.freeze({ hour: '2-digit', minute: '2-digit', second: '2-digit' });

const dateFormater = new Intl.DateTimeFormat(locale, { ...dateFormatParams });
const timestampFormater = new Intl.DateTimeFormat(locale, { ...dateFormatParams, ...timeFormatParams });

export function getTimestamp(numericTimestamp: number) {
  if (!numericTimestamp || isNaN(numericTimestamp)) return 'Invalid date';
  return timestampFormater.format(new Date(numericTimestamp));
}

export function getDate(numericTimestamp: number) {    
    if (!numericTimestamp || isNaN(numericTimestamp)) return 'Invalid date';
    return dateFormater.format(new Date(numericTimestamp));
}